export const TermsGiftingContent = {
  pageTitle: `Before we can submit the gift request, we need you to sign and agree in the section below`,
  continueButton: `Submit`,
  errorMsg: `This field is required.`,
  vanguardGiftingAuthorizationStatement: `By clicking <span class="bold">I sign and agree</span> and <span class="bold">Submit</span> below, you authorize Vanguard Marketing Corporation and/or The Vanguard Group Inc., to transfer the identified assets as instructed in this application.`,
  nonVanguardGiftingAuthorization: `By clicking <span class="bold">I sign and agree</span> and <span class="bold">Submit</span> below, you authorize Vanguard Marketing Corporation to transfer the identified assets as instructed in this application to a third party, and you irrevocably relinquish all rights, title, and interest to those assets.`,
  signerTemplate: 'I, ${signer-name}, sign and agree',
  loadingSpinner: `We're preparing your request... <br> please wait a few minutes`,
  internal: {
    pageTitle: `Script to read to client`,
    giftingHeader: `Crew cannot submit on behalf of clients.`,
    giftingDescription: `Please nudge clients eligible for CXD Gifting off the call to self submit.`,
  },
};
